import { oneDecimalPercentFormat } from 'common/formats/formats';
import { ALLOCATION_SCENARIO_METHOD_OPM } from 'pages/ValuationsAllocation/common/constants/allocation';
import { getNumberValue } from 'utillities';
import { HandleRiskFreeRateParams } from './types';

const handleRiskFreeRate = (params: HandleRiskFreeRateParams) => {
  const { cell, isApproachWithOPM, scenarioMethod } = params;

  cell.format = oneDecimalPercentFormat;
  cell.gridType = 'percentage';

  if (![ALLOCATION_SCENARIO_METHOD_OPM].includes(getNumberValue(scenarioMethod)) && !isApproachWithOPM) {
    cell.hidden = true;
  }
};

export default handleRiskFreeRate;
